const reactAppEnv = process.env.REACT_APP_ENV
let const_HOST_ADDR: string

if (reactAppEnv === 'prd') {
  const_HOST_ADDR = 'https://api.helloproteger.com'
} else {
  const_HOST_ADDR = 'https://' + reactAppEnv + '-api.helloproteger.com'
}

export const PUBLIC_SITE_URL = const_HOST_ADDR
